import {Component, OnInit} from "@angular/core";
import {UserService} from "../../services/users.service";
import {Router} from "@angular/router";
import {Auth2Service} from "../../../../services/auth2.service";
import {HttpErrorResponse} from "@angular/common/http";
import {LoggedInPageBaseComponent} from "../../../../shared-components/ui-components/logged-in-page-base/logged-in-page-base.component";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-subscription-change',
  templateUrl: './subscription-change.component.html',
  styleUrls: ['./subscription-change.component.scss'],
  standalone: false
})
export class SubscriptionChangeComponent extends LoggedInPageBaseComponent implements OnInit {
  breadCrumbs = [
    { iconClass: 'bi-house', path: 'app/users/dashboard'},
    { label: 'Dashboard', path: 'app/users/dashboard'},
    { label: 'Subscription Pricing'}
  ];

  showMessages = false;
  displayPromoCodeTextBox: boolean = false;
  messages: any[] = [];
  username: string = '';
  impersonatedEmail: any = null;

  pageName = 'Change Subscription';
  subscriptionPricePlans: any[] = [];
  savedPromoCode: string = '';
  currentIndex: number = -1;

  // @ts-ignore
  constructor(private userService: UserService,
              private routerChild: Router,
              private auth2ServiceChild: Auth2Service,
              private titleService: Title) {
    super(auth2ServiceChild, routerChild);
    this.titleService.setTitle("Scalanthropy Change Subscription");
  }

  ngOnInit() {
    this.pageErrorMessages = [];
    //Get the Subscription Prices in a table
    this.username = this.auth2ServiceChild.getUsername();
    this.impersonatedEmail = this.auth2ServiceChild.getImpersonatedEmail();
    if (this.impersonatedEmail != null && this.username != this.impersonatedEmail) {
      //impersonate emails are not allowed on this page
      this.pageErrorMessages.push({
        field: 'Impersonated Emails not allowed on page.',
        detail: 'Consultants are not allowed to change their client subscriptions.',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
      this.routerChild.navigateByUrl('app/users/dashboard');
    }
    const url: string = window.location.href;
    if (url.includes('subscription/pricing/change')) {
      this.displayPromoCodeTextBox = false;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    // @ts-ignore
    this.userService.getSubscriptionPricingV4(this.username).subscribe((result: any) => {
      if (result && result.body) {
        this.subscriptionPricePlans = result.body;
      }
    }, (err1: HttpErrorResponse) => {
      this.redirectToLogin(err1);
      this.pageErrorMessages.push({
        field: 'Subscription Plan Pricing API Error',
        detail: 'Failed to pull the Subscription Plan Pricing...',
        severity: 'error'
      });
      this.showPageErrorMessagesToUser();
    });
  }

  changeSubscription(subscriptionPricePlan: any): void {
    this.pageErrorMessages = [];
    //const promoCodeTxtEl = document.getElementById('promo-code-text-id');
    // @ts-ignore
    //let promoCodeTxt: string = promoCodeTxtEl.value;
    let promoCodeTxt: string = null;

    this.userService.changeSubscription(this.username, subscriptionPricePlan['subscriptionPlanLengthMonths'], promoCodeTxt)
      .subscribe((result: any) => {
        if (result && result.body && result.body.redirectUrl) {
          localStorage.setItem("changeSubscriptionDto", JSON.stringify(result.body));
          // @ts-ignore
          window.open(result.body.redirectUrl, '_self');
        }
      }, (err1: HttpErrorResponse) => {
        this.redirectToLogin(err1);
        this.pageErrorMessages.push({
          field: 'Subscription Plan Checkout Session API Error',
          detail: 'Failed to Change Subscription. ' + err1.error.message,
          severity: 'error'
        });
        this.showPageErrorMessagesToUser();
      })
  }

  onClearPromoCode(): void {
    this.savedPromoCode = '';
  }

  onCancel(): void {
    this.routerChild.navigateByUrl('app/users/dashboard');
  }
}
